import { WizardStep } from "@/components/dynamicWizard";
import { BASE_URL, SERVER_BASE_URL } from "./base";
import { BlogContent } from "@/data/blogData";

export const WizardService = {
  async wizardCatagoryList(cat: string): Promise<WizardStep[]> {
    const wizardDetail = await fetch(`${BASE_URL}/wiz/${cat}`);
    const wizard = await wizardDetail.json();
    return wizard.data;
  },
  async wizardList(): Promise<WizardStep[]> {
    const wizardDetail = await fetch(`${BASE_URL}/wiz`);
    const wizard = await wizardDetail.json();
    return wizard.data;
  },
  async wizardMetaList(cat: string): Promise<BlogContent> {
    const wizardMeta = await fetch(`${SERVER_BASE_URL}/wiz/meta/${cat}`);

    const wizard = await wizardMeta.json();
    return wizard.data;
  },
}